<nz-tabset>
  <nz-tab nzTitle="AI Coaching">
    <div class="vertical tab-content">
      <div class="original-section">
        {{ range.message }}
      </div>
      @if (!aiFeedback()) {
        <div class="horizontal">
          <button class="fit-content" nz-button nzType="primary" nzSize="large" (click)="getAiFeedback(true)">
            <span nz-icon style="font-size: 20px" class="material-symbols-rounded">article</span>
            Generate AI Feedback
          </button>
        </div>

        @if (isLoadingImprovedResponse() || isLoadingSuggestions()) {
          <app-ai-is-loading [isLoading]="isLoading()"></app-ai-is-loading>
          <nz-skeleton></nz-skeleton>
        }
      } @else {
        <button
          class="fit-content right"
          nz-button
          nzType="default"
          nzSize="small"
          (click)="onRegenerateAiImprovementsClick()"
        >
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
          Regenerate
        </button>
        <div class="vertical no-gap">
          <h3>Suggestions</h3>
          <div class="suggessions-section">
            @if (isLoadingSuggestions()) {
              <app-ai-is-loading [isLoading]="isLoading()"></app-ai-is-loading>
              <nz-skeleton></nz-skeleton>
            } @else {
              <ul>
                @for (item of aiFeedback()?.improvementSuggestions; track $index) {
                  <li [innerHTML]="item | markdownIt"></li>
                }
              </ul>
            }
          </div>
        </div>

        <div class="vertical no-gap">
          <h3>Improved Response</h3>
          <div class="improvements-section">
            @if (isLoadingImprovedResponse()) {
              <app-ai-is-loading [isLoading]="isLoading()"></app-ai-is-loading>
              <nz-skeleton></nz-skeleton>
            } @else {
              <div [innerHTML]="aiFeedback()?.rewrittenResponse | markdownIt"></div>
            }
          </div>
        </div>
      }
    </div>
  </nz-tab>
  <nz-tab nzTitle="Comments">
    <div class="vertical tab-content">
      <div class="original-section">
        {{ range.message }}
      </div>
      <div class="comment-list">
        @for (feedback of range.sessionMessage.publicSubData?.salesHumanFeedbackList; track $index) {
          <nz-comment
            [nzAuthor]="getBoardName(getBoard(feedback.createdById))"
            [nzDatetime]="getCommentsDiff(feedback.createdTimeStr)"
          >
            <nz-avatar nz-comment-avatar class="comment-avatar"></nz-avatar>
            <app-board-icon
              class="comment-user-portrait"
              [size]="28"
              [board]="getBoard(feedback.createdById)"
            ></app-board-icon>
            <nz-comment-content class="comment-content">
              <div class="feedback-content">
                {{ feedback.feedback }}
              </div>
            </nz-comment-content>
          </nz-comment>
        }

        <nz-comment>
          <nz-avatar nz-comment-avatar class="comment-avatar"></nz-avatar>
          <app-board-icon class="comment-user-portrait" [size]="28" [board]="myPersonalBoard()"></app-board-icon>

          <nz-comment-content>
            <nz-form-item class="comment-content">
              <textarea [(ngModel)]="feedbackInput" [placeholder]="'Feedback'" nz-input rows="3"></textarea>
            </nz-form-item>
            <nz-form-item class="add-comment-button">
              <button nz-button nzType="primary" (click)="onFeedbackSubmit()">Add Feedback</button>
            </nz-form-item>
          </nz-comment-content>
        </nz-comment>
      </div>
    </div>
  </nz-tab>
</nz-tabset>
